import { lerp, deltaTime } from '@/utils/cursor'

export const uiButton = () =>
  ({
    isHovering: false,
    raf: null as number | null,
    mouse: { x: 0.5, y: 0.5 }, // Mouse position
    cursor: { x: 0.5, y: 0.5 }, // Custom Cursor position
    speed: 0.05,

    init() {
      if (!this.$refs.cursor) return

      this.$watch('isHovering', (value: any) => {
        if (value) this.addCursorListener()
        else this.removeCursorListener()
      })
    },

    setMouseCoordinates() {
      // Calculate lerped values (gives cursor inertia)
      this.cursor.x = lerp(this.cursor.x, this.mouse.x, this.speed)
      this.cursor.y = lerp(this.cursor.y, this.mouse.y, this.speed)

      this.$refs.cursor.style.setProperty('--cursor-x', String(this.cursor.x))
      this.$refs.cursor.style.setProperty('--cursor-y', String(this.cursor.y))

      // Determine isolated inertia to calculate when to cancel the requestAnimationFrame
      const delta = deltaTime(
        this.mouse.x,
        this.mouse.y,
        this.cursor.x,
        this.cursor.y,
      )

      if (delta < 0.001) {
        if (this.raf) cancelAnimationFrame(this.raf)
        this.raf = null
        return
      }

      this.raf = requestAnimationFrame(() => this.setMouseCoordinates())
    },

    onMouseMove(event: any) {
      // Get normalized mouse coordinates [0, 1]
      const button = this.$refs?.button
      if (!button) return
      const rect = this.$refs.button.getBoundingClientRect()

      this.mouse.x = event.clientX - rect.right
      this.mouse.y = event.clientY - rect.bottom

      if (!this.raf)
        this.raf = requestAnimationFrame(() => this.setMouseCoordinates())
    },

    addCursorListener() {
      window.addEventListener('mousemove', (event) => this.onMouseMove(event))
      this.raf = requestAnimationFrame(() => this.setMouseCoordinates())
    },

    removeCursorListener() {
      window.removeEventListener('mousemove', (event) =>
        this.onMouseMove(event),
      )
      if (this.raf) cancelAnimationFrame(this.raf)
    },

    destroy() {
      this.removeCursorListener()
    },
  }) as any
